import React, { useState } from 'react';

const trackEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, { app: 'find_my_business', ...params });
  }
};

function EmailCapture({ onSubmit, formData }) {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email && email.includes('@')) {
      trackEvent('email_captured', { source: 'quiz_gate' });
      onSubmit(email, formData);
    }
  };

  return (
    <div className="email-capture">
      <h2>Almost There! 🎯</h2>
      <p style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
        Enter your email to get your personalized business recommendations
      </p>
      
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          required
          className="email-input"
        />
        <button type="submit" className="submit-btn">
          Get My Business Ideas →
        </button>
      </form>

      <p style={{ fontSize: '0.9rem', marginTop: '1rem', opacity: 0.8 }}>
        No spam. Just your results.
      </p>
    </div>
  );
}

export default EmailCapture;
